import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { Row, Col } from "react-bootstrap";
import {
  Institute,
  DSRCodes,
  Society,
} from "../../ReusableComponents/NCLAdminDropdowns";
import SubHeadersDataTable from "../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";
import { useSelector, useDispatch } from "react-redux";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import CurrentRegistations from "./CurrentRegistartions";
import * as XLSX from "xlsx";
import axiosInstance from "../../ReusableComponents/Axios";
import { ExportXlButton } from "../../ReusableComponents/CommonComponents";
import { SelecTInstData } from "../../Redux/Reducers/Common/InstValue";
import { AssessmentDates } from "../../ReusableComponents/CommonApis";
import LiveAssessmentDetails from "./LiveAssessmentDetails";
import { useOutletContext } from "react-router-dom";
const AssessmentParticipationReport = (props) => {
  const dispatch = useDispatch();
  const outletContext = useOutletContext();
  const YH = outletContext?.YH;
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [SelectINID, SetSelectINID] = useState();
  const [SocietyId, SetSocietyId] = useState("0");
  const [Load, SetLoad] = useState(false);
  const [SRSData, SetSRSData] = useState("0");
  const [SchoolValues, setSchoolValues] = useState("");
  const [InstituteValues, SetInstituteValues] = useState();

  const [CRegistrations, SetCRegistrations] = useState();
  const [CRTotal, SetCRTotal] = useState();

  const [ASDetails, SetASDetails] = useState("APR");
  const [HCApi, SetHCApi] = useState(1);

  const GetInstituteData = async () => {
    // SetLoad((prev) => !prev);
    SetInstituteValues();
    try {
      const response = await axiosInstance.get(
        `/NCLAdmin/GetOverallParticipationAndRegistrationCount?ContestCreationId=${SelectDate?.value}&InstituteId=${SelectINID?.Value}&AssessmentType=${SelectDate?.assessmentType}&SocietyId=${SocietyId?.value || 0}`
      );
      SetInstituteValues(response.data);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching School data:", error);
      return [];
    }
  };

  const GetSchools = async () => {
    SetLoad((prev) => !prev);

    setSchoolValues();
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetOverallGradewiseRegVsParticipated?AssessmentType=${SelectDate?.assessmentType
        }&ContestCreationId=${SelectDate?.value}&InstituteId=${SelectINID?.Value
        }&RegionHierarchyId=${SRSData?.value || 0}&SocietyId=${SocietyId?.value || 0
        }`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      const registered = {};
      const participated = {};
      for (let grade = 1; grade <= 12; grade++) {
        registered[`registered${grade}`] = 0;
        participated[`participated${grade}`] = 0;
      }

      const totalCounts = response.data.reduce(
        (sum, school) => {
          let schoolRegisteredTotal = 0;
          let schoolParticipatedTotal = 0;

          for (let grade = 1; grade <= 12; grade++) {
            const reg = school[`registered${grade}`] || 0;
            const part = school[`participated${grade}`] || 0;

            registered[`registered${grade}`] += reg;
            participated[`participated${grade}`] += part;

            schoolRegisteredTotal += reg;
            schoolParticipatedTotal += part;
          }

          sum.totalRegistered += schoolRegisteredTotal;
          sum.totalParticipated += schoolParticipatedTotal;

          return sum;
        },
        { totalRegistered: 0, totalParticipated: 0 }
      );

      const Totaldata = {
        schoolName: "Total",
        ...registered,
        ...participated,
        ...totalCounts,
      };

      setSchoolValues([Totaldata, ...response.data]);
      GetInstituteData();
      // SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching School data:", error);
      return [];
    }
  };
  useEffect(() => {
    if (SelectINID && SelectDate?.value && !SchoolValues) {
      GetSchools();
    }
  }, [SelectDate?.value, SelectINID]);

  const HandleInstituteChange = (e) => {
    SetSelectINID(e);
    SetSRSData("0");
    SetSocietyId("0");
  };
  const generateGradeColumns = (prefix) =>
    Array.from({ length: 12 }, (_, index) => ({
      name: String(index + 1),
      selector: `${prefix}${index + 1}`,
      sortable: true,
    }));
  const Columns = [
    { name: "School Name", selector: "schoolName", sortable: true },
    { name: "District", selector: "district", sortable: true },
    { name: "Grade wise Registered", subColumns: generateGradeColumns("registered"), },
    { name: "Total Registered", selector: "totalRegistered", sortable: true },
    { name: "Grade wise Participated", subColumns: generateGradeColumns("participated"), },
    { name: "Total Participated", selector: "totalParticipated", sortable: true, },
    { name: "Contact Name", selector: "contactName", sortable: true },
    { name: "Contact Phone", selector: "contactPhone", sortable: true },
  ];
  const InstituteColumns = [
    { name: "Grade", selector: "schoolId", sortable: true, cell: (row) => "Total" },
    { name: "Grade wise Registered", subColumns: generateGradeColumns("registered"), },
    { name: "Grade wise Participated", subColumns: generateGradeColumns("participated"), },
  ];
  const HandleApis = () => {
    if (ASDetails === "APR") {
      GetSchools();
    } else {
      SetHCApi(HCApi + 1);
    }
  };
  const Downloadxl = () => {
    if (ASDetails === "APR") {
      Downloadapdata();
    } else {
      DownloadCRegistrations();
    }
  };

  function _newDate() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const Downloadapdata = async () => {
    const headers = `
    <tr>
      <th rowspan="2">S.No</th>
      <th rowspan="2">School Name</th>
      <th rowspan="2">District</th>
      <th colspan="12">Grade wise Registered</th>
      <th rowspan="2">Total Registered</th>
      <th colspan="12">Grade wise Participated</th>
      <th rowspan="2">Total Participated</th>
      <th rowspan="2">Contact Name</th>
      <th rowspan="2">Contact Phone</th>
    </tr>
    <tr>
      ${Array.from({ length: 12 }, (_, i) => `<th>${i + 1}</th>`).join("")}
      ${Array.from({ length: 12 }, (_, i) => `<th>${i + 1}</th>`).join("")}
    </tr>`;

    const rows = SchoolValues?.map(
      (item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.schoolName}</td>
      <td>${item.district ?? ""}</td>
      <td>${item.registered1}</td>
      <td>${item.registered2}</td>
      <td>${item.registered3}</td>
      <td>${item.registered4}</td>
      <td>${item.registered5}</td>
      <td>${item.registered6}</td>
      <td>${item.registered7}</td>
      <td>${item.registered8}</td>
      <td>${item.registered9}</td>
      <td>${item.registered10}</td>
      <td>${item.registered11}</td>
      <td>${item.registered12}</td>
      <td>${item.totalRegistered}</td>
      <td>${item.participated1}</td>
      <td>${item.participated2}</td>
      <td>${item.participated3}</td>
      <td>${item.participated4}</td>
      <td>${item.participated5}</td>
      <td>${item.participated6}</td>
      <td>${item.participated7}</td>
      <td>${item.participated8}</td>
      <td>${item.participated9}</td>
      <td>${item.participated10}</td>
      <td>${item.participated11}</td>
      <td>${item.participated12}</td>
      <td>${item.totalParticipated}</td>
      <td>${item.contactName ?? ""}</td>
      <td>${item.contactPhone ?? ""}</td>
    </tr>`
    ).join("");

    const html = `
    <table border="1">
      ${headers}
      ${rows}
    </table>`;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const tableElement = doc.querySelector("table");

    const worksheet = XLSX.utils.table_to_sheet(tableElement);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Assessment Participation"
    );

    try {
      const payload = {
        userTypeId: items?.userTypeId || 0,
        userId: items?.userId || 0,
        reportType: "Assessment Participation",
        contestCreationId: SelectDate?.value || 0,
        assessmentTypeId: SelectDate?.assessmentType || 0,
        instituteId: SelectINID?.Value || 0,
      };

      await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);
    } catch (error) {
      console.error("Logging failed:", error);
    }

    XLSX.writeFile(
      workbook,
      `${SelectINID.Code}_${SRSData?.display || SocietyId?.display || ""
      }_StudentRegistrations_${SelectDate?.examStartDate}.xlsx`
    );
  };

  const DownloadCRegistrations = async () => {
    const headers = `
    <tr>
      <th rowspan="2">S.No</th>
      <th rowspan="2">School Name</th>
      <th rowspan="2">District</th>
      <th colspan="12">Grade wise Registered</th>
      <th rowspan="2">Total Registered</th>
      <th rowspan="2">Contact Name</th>
      <th rowspan="2">Contact Phone</th>
    </tr>
    <tr>
      ${Array.from({ length: 12 }, (_, i) => `<th>${i + 1}</th>`).join("")}
    </tr>`;

    const rows = CRegistrations?.map(
      (item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.schoolName}</td>
      <td>${item.district}</td>
      <td>${item.grade1}</td>
      <td>${item.grade2}</td>
      <td>${item.grade3}</td>
      <td>${item.grade4}</td>
      <td>${item.grade5}</td>
      <td>${item.grade6}</td>
      <td>${item.grade7}</td>
      <td>${item.grade8}</td>
      <td>${item.grade9}</td>
      <td>${item.grade10}</td>
      <td>${item.grade11}</td>
      <td>${item.grade12}</td>
      <td>${item.totalRegCount}</td>
      <td>${item.contactName}</td>
      <td>${item.contactPhone}</td>
    </tr>`
    ).join("");

    const html = `
    <table border="1">
      ${headers}
      ${rows}
    </table>`;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const tableElement = doc.querySelector("table");

    const worksheet = XLSX.utils.table_to_sheet(tableElement);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Current Registrations");

    try {
      const payload = {
        userTypeId: items?.userTypeId || 0,
        userId: items?.userId || 0,
        reportType: "Current Registrations",
        contestCreationId: 0,
        assessmentTypeId: 0,
        instituteId: SelectINID?.Value || 0,
      };

      await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);
    } catch (error) {
      console.error("Logging failed:", error);
    }

    XLSX.writeFile(
      workbook,
      `${SelectINID.Code}_${SRSData?.display || SocietyId?.display || ""
      }_CurrentRegistrations_${SelectDate?.examStartDate}.xlsx`
    );
  };

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <TabViewValues
          Tabs={[
            { Name: "Live Assessment Participation", Value: "LAPR" },
            { Name: "Assessment Participation", Value: "APR" },
            { Name: "Current Registrations", Value: "CR" },
          ]}
          Selectedtab={ASDetails}
          onClick={(e) => {
            if (e === "LAPR") { YH?.(true); }
            else { YH?.(false); }
            SetASDetails(e);
          }}
        />
        <div className="MainHeading" style={{ marginTop: "15px" }}>
          {ASDetails === "APR"
            ? "Assessment Participation Report"
            : ASDetails === "LAPR" ? "Live Assessment Participation Report " : "Current Registrations"}
        </div>
        {ASDetails === "LAPR" ?
          <LiveAssessmentDetails />
          : <>
            <Row className="mt-2">
              <Col md={10}>
                <div className="InputFIlters">
                  <label>Report Input</label>
                  <br />
                  <Row>
                    <Col>
                      <Institute
                        className="NCLDropdown w-100"
                        StoreValue={SetSelectINID}
                        SOption={SelectINID?.Value}
                        onChange={(e) => {
                          HandleInstituteChange(e);
                          dispatch(SelecTInstData({ InValue: e.Value }));
                        }}
                        labelname={
                          <div className="DropdownHeader">Institute :</div>
                        }
                      />
                    </Col>

                    {(SelectINID?.Value === 1 || SelectINID?.Value === 3) && (
                      <Col>
                        <DSRCodes
                          className="NCLDropdown w-100"
                          PId={SelectINID?.Value}
                          id="0"
                          StoreValue={SetSRSData}
                          onChange={(e) => {
                            SetSRSData(e);
                          }}
                          labelname={<div className="DropdownHeader">Region :</div>}
                        />
                      </Col>
                    )}

                    {(SelectINID?.Value === 8 || SelectINID?.Value === 9 || SelectINID?.Value === 5) && (
                      <Col>
                        <Society
                          className="NCLDropdown w-100"
                          PId={SelectINID?.Value}
                          id="0"
                          StoreValue={SetSocietyId}
                          onChange={(e) => {
                            SetSocietyId(e);
                          }}
                          labelname={
                            <div className="DropdownHeader">Society :</div>
                          }
                        />
                      </Col>
                    )}
                    {ASDetails === "APR" && SelectINID && (
                      <Col>
                        <AssessmentDates
                          InstId={SelectINID?.Value}
                          Society={SocietyId?.value}
                          labelname={
                            <div className="DropdownHeader">Assessment Date :</div>
                          }
                        />
                      </Col>
                    )}

                    <Col>
                      <div className="d-flex align-items-center">
                        <button
                          onClick={() => HandleApis()}
                          className="Buttons m-3"
                        >
                          Go
                        </button>
                        <ExportXlButton
                          Name="Export to Excel"
                          Click={() => Downloadxl()}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col md={2}>
                <div className="InputFIlters">
                  <Row className="mb-2">
                    <strong>
                      <span className="text-success">Institute:</span>{" "}
                      {SelectINID?.Code}
                    </strong>
                  </Row>
                  <Row className="mb-2">
                    <strong>
                      <span className="text-success">Total Registered:</span>{" "}
                      {ASDetails === "APR"
                        ? InstituteValues?.[0]?.totalRegistered
                        : CRTotal?.totalRegCount || 0}{" "}
                    </strong>
                  </Row>

                  {ASDetails === "APR" && (
                    <Row className="mb-2">
                      <strong>
                        <span className="text-success">Total Participated:</span>
                        {InstituteValues?.[0]?.totalParticipated}{" "}
                      </strong>
                    </Row>
                  )}
                </div>
              </Col>
            </Row>

            {ASDetails === "APR" ? (
              <>
                <div className="SubHeading mt-3">
                  Overall Grade wise Registered vs Participated
                </div>
                <div>
                  {InstituteValues && (
                    <SubHeadersDataTable
                      data={InstituteValues}
                      columns={InstituteColumns}
                      className="NCLDataTable Card mt-2"
                      ShowPagination={false}
                      ShowPagecount={false}
                    />
                  )}
                  {SchoolValues && (
                    <SubHeadersDataTable
                      data={SchoolValues}
                      columns={Columns}
                      className="NCLDataTable Card mt-2"
                      ShowPagination={false}
                      ShowPagecount={false}
                    />
                  )}</div>
              </>
            ) : (
              <CurrentRegistations
                InstId={SelectINID}
                RegionId={SRSData}
                SocietyId={SocietyId?.value}
                try={HCApi}
                GetData={SetCRegistrations}
                GetTotalcount={SetCRTotal}
              />
            )}
          </>}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default AssessmentParticipationReport;